
// M008 article teaser
function updateArticleTeaser() {

    if ($(".articleTeaserContainer").length > 0) {
        $(".articleTeaserContainer").each(function () {

            var hh = 0;
            var th = 0;

            $(this).find(".articleTeaserCol").children("h3").css("height", "auto");
            $(this).find(".articleTeaserCol").children(".articleTeaser").css("height", "auto");

            //headlines
            $(this).find(".articleTeaserCol").each(function () {
                if ($(this).children("h3").height() > hh) {
                    hh = Math.ceil($(this).children("h3").height());
                }
                ;
            });
            if (hh > 0) {
                $(this).find(".articleTeaserCol").children("h3").css("height", hh + "px");
            }

            //teaser
            $(this).find(".articleTeaserCol").each(function () {
                if ($(this).children(".articleTeaser").height() > th) {
                    th = Math.ceil($(this).children(".articleTeaser").height());
                }
                ;
            });
            if (th > 0) {
                $(this).find(".articleTeaserCol").children(".articleTeaser").css("height", th + "px");
            }
        });
    }
}